import { getLocation } from "@faire/globals/browser/getLocation";
import { parsePath } from "history";

import { IRoutingContext } from "./types";

export function getShouldUseSoftNavigation(
  routingContext: IRoutingContext,
  toStr: string
): boolean {
  if (routingContext.getShouldUseSoftNavigation) {
    const currentLocation = getLocation();
    return routingContext.getShouldUseSoftNavigation(
      currentLocation ?? { pathname: "", search: "" },
      parsePath(toStr)
    );
  } else {
    return true;
  }
}
